module.exports = __webpack_public_path__ + "img/blzccz.edafe80a.png";